/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A unique identifier for the re-usable type of task.
 */
export enum TaskName {
  INITIATE_INCOME_QUALIFICATION = 'initiate_income_qualification',
  DEFINE_SCOPE_OF_WORK = 'define_scope_of_work',
  PROVIDE_HOMEOWNER_DETAILS = 'provide_homeowner_details',
  PROVIDE_OTHER_HOMEOWNER_DETAILS = 'provide_other_homeowner_details',
  PROVIDE_INCOME_ENHANCED_INCENTIVE = 'provide_income_enhanced_incentive',
  PROVIDE_ENERGY_SOURCES_AND_UTILITIES = 'provide_energy_sources_and_utilities',
  PROVIDE_ENERGY_USES = 'provide_energy_uses',
  PROVIDE_SERVICES = 'provide_services',
  PROVIDE_SITE_DETAILS = 'provide_site_details',
  ENROLL_IN_REQUIRED_INITIATIVES = 'enroll_in_required_initiatives',
  PROVIDE_EXISTING_EQUIPMENT_AND_SOURCES = 'provide_existing_equipment_and_sources',
  PROVIDE_EQUIPMENT_REMOVED_DETAILS = 'provide_equipment_removed_details',
  PROVIDE_ENVELOPE_DETAILS_HEAR = 'provide_envelope_details_hear',
  PROVIDE_EQUIPMENT_INSTALLED_DETAILS = 'provide_equipment_installed_details',
  PROVIDE_HEAT_PUMP_INSTALLED_DETAILS = 'provide_heat_pump_installed_details',
  PROVIDE_WATER_HEATER_INSTALLED_DETAILS = 'provide_water_heater_installed_details',
  PROVIDE_EVAPORATIVE_COOLER_INSTALLED_DETAILS = 'provide_evaporative_cooler_installed_details',
  SUBMIT_REBATE_DETAILS_3CREN = 'submit_rebate_details_3cren',
  SUBMIT_REBATE_DETAILS_PCE = 'submit_rebate_details_pce',
  SUBMIT_REBATE_DETAILS_HIASP = 'submit_rebate_details_hiasp',
  SUBMIT_REBATE_DETAILS_RECO = 'submit_rebate_details_reco',
  SUBMIT_REBATE_DETAILS_CAHEEHRA = 'submit_rebate_details_caheehra',
  SUBMIT_REBATE_DETAILS_WIHEAR = 'submit_rebate_details_wihear',
  SUBMIT_REBATE_DETAILS_WIHEAR_WX = 'submit_rebate_details_wihear_wx',
  SUBMIT_REBATE_DETAILS_CATECH = 'submit_rebate_details_catech',
  SUBMIT_REBATE_DETAILS_3CE = 'submit_rebate_details_3ce',
  SUBMIT_REBATE_DETAILS_GAHEAR = 'submit_rebate_details_gahear',
  SUBMIT_REBATE_DETAILS_SUNRUN = 'submit_rebate_details_sunrun',
  SUBMIT_REBATE_DETAILS_CATECH_WH = 'submit_rebate_details_catech_wh',
  SUBMIT_REBATE_DETAILS_MASS_SAVE = 'submit_rebate_details_mass_save',
  SUBMIT_REBATE_DETAILS_NY_CLEAN_HEAT = 'submit_rebate_details_ny_clean_heat',
  SUBMIT_REBATE_DETAILS_CO_XCEL = 'submit_rebate_details_co_xcel',
  SUBMIT_REBATE_DETAILS_CO_XCEL_AURORA = 'submit_rebate_details_co_xcel_aurora',
  SUBMIT_REBATE_DETAILS_CO_DR_COG = 'submit_rebate_details_co_dr_cog',
  SUBMIT_REBATE_DETAILS_CA_TECH_SFV = 'submit_rebate_details_ca_tech_sfv',
  SUBMIT_REBATE_DETAILS_COHEAR = 'submit_rebate_details_cohear',
  SUBMIT_REBATE_DETAILS_LADWP = 'submit_rebate_details_ladwp',
  PROVIDE_UTILITY_CREDENTIALS = 'provide_utility_credentials',
  UPLOAD_PROPOSED_SCOPE_OF_WORK = 'upload_proposed_scope_of_work',
  SIGN_SCOPE_OF_WORK_CO_HEAR = 'sign_scope_of_work_co_hear',
  UPLOAD_UTILITY_BILLS = 'upload_utility_bills',
  SIGN_IRA_TENANT_OWNER_ACKNOWLEDGMENT = 'sign_ira_tenant_owner_acknowledgment',
  SIGN_PROPOSED_INVOICE_WI_HEAR = 'sign_proposed_invoice_wi_hear',
  SIGN_UTILITY_BILL_IMPACT_WI_HEAR = 'sign_utility_bill_impact_wi_hear',
  PROVIDE_RMI_GREEN_UPDATE_CALCULATOR_DETAILS = 'provide_rmi_green_update_calculator_details',
  SIGN_UTILITY_BILL_IMPACT_CO_HEAR = 'sign_utility_bill_impact_co_hear',
  CONFIRM_PRE_INSTALL_DETAILS = 'confirm_pre_install_details',
  PROVIDE_INCOME_ESTIMATE = 'provide_income_estimate',
  VERIFY_INCOME_QUALIFICATION = 'verify_income_qualification',
  UPLOAD_MANUAL_J_REPORT = 'upload_manual_j_report',
  PROVIDE_WX_PROOF = 'provide_wx_proof',
  OPTIONAL_PRE_APPROVAL_RESERVATION = 'optional_pre_approval_reservation',
  PROVIDE_RESERVATION_DETAILS_CA_TECH_SFV = 'provide_reservation_details_ca_tech_sfv',
  UPLOAD_MANUAL_S_REPORT = 'upload_manual_s_report',
  CREATE_INITIAL_INVOICE = 'create_initial_invoice',
  APPLY_FOR_INCOME_VERIFICATION = 'apply_for_income_verification',
  UPLOAD_PROPOSED_INVOICE = 'upload_proposed_invoice',
  SUNRUN_DETAILS = 'sunrun_details',
  OPPORTUNITY_ATTEMPT_CONTACT = 'opportunity_attempt_contact',
  OPPORTUNITY_FIRST_CONTACT = 'opportunity_first_contact',
  OPPORTUNITY_SCHEDULE_APPOINTMENT = 'opportunity_schedule_appointment',
  OPPORTUNITY_VISIT_HOME = 'opportunity_visit_home',
  SIGN_TECH_CUSTOMER_AGREEMENT = 'sign_tech_customer_agreement',
  HVAC_SYSTEM = 'hvac_system',
  WATER_HEATING_SYSTEM = 'water_heating_system',
  EXISTING_ELECTRICAL_SYSTEM = 'existing_electrical_system',
  PROPOSED_ELECTRICAL_SYSTEM = 'proposed_electrical_system',
  EXISTING_WEATHERIZATION_DETAILS = 'existing_weatherization_details',
  PROPOSED_WEATHERIZATION_DETAILS = 'proposed_weatherization_details',
  PROVIDE_VENTILATION_DETAILS = 'provide_ventilation_details',
  PROVIDE_HEATING_EQUIPMENT_DETAILS = 'provide_heating_equipment_details',
  RESOLVE_SUBMIT_TASKS = 'resolve_submit_tasks',
  CONFIRM_SITE_DETAILS = 'confirm_site_details',
  REVIEW_ENERGY_USAGE_GAS = 'review_energy_usage_gas',
  REVIEW_ENERGY_USAGE_ELECTRIC = 'review_energy_usage_electric',
  REVIEW_ENERGY_USAGE_DELIVERED_FUEL = 'review_energy_usage_delivered_fuel',
  REVIEW_PRE_INSTALL_DETAILS = 'review_pre_install_details',
  REVIEW_SCOPE_OF_WORK = 'review_scope_of_work',
  CONFIRM_MULTIPLIERS = 'confirm_multipliers',
  DETERMINE_EQUIPMENT_REMOVED_EFFICIENCY = 'determine_equipment_removed_efficiency',
  PROVIDE_EQUIPMENT_CATALOG_DETAILS = 'provide_equipment_catalog_details',
  DETERMINE_SHARE_REBATE_AMOUNT = 'determine_share_rebate_amount',
  SUBMIT_FOR_PREAPPROVAL_3CREN = 'submit_for_preapproval_3cren',
  SUBMIT_FOR_PREAPPROVAL_HIASP = 'submit_for_preapproval_hiasp',
  SUBMIT_FOR_PREAPPROVAL_CAHEEHRA = 'submit_for_preapproval_caheehra',
  SUBMIT_FOR_PREAPPROVAL_WIHEAR = 'submit_for_preapproval_wihear',
  SUBMIT_FOR_PREAPPROVAL_WIHEAR_WX = 'submit_for_preapproval_wihear_wx',
  SUBMIT_FOR_PREAPPROVAL_CATECH = 'submit_for_preapproval_catech',
  SUBMIT_FOR_PREAPPROVAL_3CE = 'submit_for_preapproval_3ce',
  SUBMIT_FOR_PREAPPROVAL_GAHEAR = 'submit_for_preapproval_gahear',
  SUBMIT_FOR_PREAPPROVAL_SUNRUN = 'submit_for_preapproval_sunrun',
  SUBMIT_FOR_PREAPPROVAL_CATECH_WH = 'submit_for_preapproval_catech_wh',
  SUBMIT_FOR_PREAPPROVAL_COHEAR = 'submit_for_preapproval_cohear',
  SUBMIT_FOR_PREAPPROVAL_CO_DR_COG = 'submit_for_preapproval_co_dr_cog',
  SUBMIT_FOR_PREAPPROVAL_CA_TECH_SFV = 'submit_for_preapproval_ca_tech_sfv',
  CONFIRM_PREAPPROVAL_3CREN = 'confirm_preapproval_3cren',
  CONFIRM_PREAPPROVAL_PCE = 'confirm_preapproval_pce',
  CONFIRM_PREAPPROVAL_HIASP = 'confirm_preapproval_hiasp',
  CONFIRM_PREAPPROVAL_CAHEEHRA = 'confirm_preapproval_caheehra',
  CONFIRM_PREAPPROVAL_WIHEAR = 'confirm_preapproval_wihear',
  CONFIRM_PREAPPROVAL_WIHEAR_WX = 'confirm_preapproval_wihear_wx',
  CONFIRM_PREAPPROVAL_CATECH = 'confirm_preapproval_catech',
  CONFIRM_PREAPPROVAL_3CE = 'confirm_preapproval_3ce',
  CONFIRM_PREAPPROVAL_GAHEAR = 'confirm_preapproval_gahear',
  CONFIRM_PREAPPROVAL_SUNRUN = 'confirm_preapproval_sunrun',
  CONFIRM_PREAPPROVAL_CATECH_WH = 'confirm_preapproval_catech_wh',
  CONFIRM_PREAPPROVAL_COHEAR = 'confirm_preapproval_cohear',
  CONFIRM_PREAPPROVAL_CO_DR_COG = 'confirm_preapproval_co_dr_cog',
  CONFIRM_PREAPPROVAL_CA_TECH_SFV = 'confirm_preapproval_ca_tech_sfv',
  CREATE_OFFER_LETTER_DOCUMENT = 'create_offer_letter_document',
  REVIEW_MANUAL_J_REPORT = 'review_manual_j_report',
  REVIEW_INCOME_QUALIFICATION = 'review_income_qualification',
  UPLOAD_FUEL_SWITCHING_CALCULATOR = 'upload_fuel_switching_calculator',
  UPLOAD_GREEN_UPDATE_CALCULATOR = 'upload_green_update_calculator',
  UPLOAD_EQUIPMENT_CERTIFICATES = 'upload_equipment_certificates',
  START_INCOME_QUALIFICATION = 'start_income_qualification',
  VALIDATE_ELIGIBILITY = 'validate_eligibility',
  REVIEW_SIGNED_TECH_CUSTOMER_AGREEMENT = 'review_signed_tech_customer_agreement',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_3CREN = 'submit_preapproval_follow_up_3cren',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_PCE = 'submit_preapproval_follow_up_pce',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_HIASP = 'submit_preapproval_follow_up_hiasp',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_CAHEEHRA = 'submit_preapproval_follow_up_caheehra',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_CATECH = 'submit_preapproval_follow_up_catech',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_CATECH_WH = 'submit_preapproval_follow_up_catech_wh',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_GAHEAR = 'submit_preapproval_follow_up_gahear',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_WIHEAR = 'submit_preapproval_follow_up_wihear',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_WIHEAR_WX = 'submit_preapproval_follow_up_wihear_wx',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_SUNRUN = 'submit_preapproval_follow_up_sunrun',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_COHEAR = 'submit_preapproval_follow_up_cohear',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_CO_DR_COG = 'submit_preapproval_follow_up_co_dr_cog',
  SUBMIT_PREAPPROVAL_FOLLOW_UP_CA_TECH_SFV = 'submit_preapproval_follow_up_ca_tech_sfv',
  PROVIDE_SCHEDULED_INSTALL_DATE = 'provide_scheduled_install_date',
  CONFIRM_INSTALL_DATES = 'confirm_install_dates',
  CONFIRM_PROJECT_FINAL_COSTS = 'confirm_project_final_costs',
  DECOMMISSIONING_CHECKLIST_DATA = 'decommissioning_checklist_data',
  DECOMMISSIONING_CHECKLIST_DATA_COLLECTION = 'decommissioning_checklist_data_collection',
  COMBUSTION_SAFETY_TESTING = 'combustion_safety_testing',
  MECHANICAL_VENTILATION = 'mechanical_ventilation',
  SIGN_IRA_COMBUSTION_VENTILATION_FORM_WI_HEAR = 'sign_ira_combustion_ventilation_form_wi_hear',
  SIGN_FINAL_INVOICE_WI_HEAR = 'sign_final_invoice_wi_hear',
  SIGN_FINAL_INVOICE_GA_HEAR = 'sign_final_invoice_ga_hear',
  SIGN_FINAL_INVOICE_CO = 'sign_final_invoice_co',
  SIGN_SIGNATURE_PACKET_HIASP = 'sign_signature_packet_hiasp',
  SIGN_OFFER_LETTER_WI_HEAR = 'sign_offer_letter_wi_hear',
  SIGN_PRE_APPROVAL_PACKET_3CREN = 'sign_pre_approval_packet_3cren',
  SIGN_APPLICATION_MASS_SAVE = 'sign_application_mass_save',
  SIGN_APPLICATION_CO_XCEL = 'sign_application_co_xcel',
  SIGN_APPLICATION_CO_XCEL_AURORA = 'sign_application_co_xcel_aurora',
  SIGN_APPLICATION_CO_XCEL_MOUNTAIN_ENERGY = 'sign_application_co_xcel_mountain_energy',
  SIGN_REBATE_ASSIGNMENT_FORM = 'sign_rebate_assignment_form',
  UNSIGNED_FINAL_INVOICE_CO = 'unsigned_final_invoice_co',
  UPLOAD_FINAL_INVOICE = 'upload_final_invoice',
  UPLOAD_PHOTOS_OF_INSTALLED_MEASURES = 'upload_photos_of_installed_measures',
  UPLOAD_PROJECT_SCOPE_OF_WORK = 'upload_project_scope_of_work',
  UPLOAD_DEMAND_RESPONSE_EVIDENCE = 'upload_demand_response_evidence',
  UPLOAD_PERMIT = 'upload_permit',
  UPLOAD_APPLICATION_CO_XCEL_AURORA = 'upload_application_co_xcel_aurora',
  DOWNLOAD_APPLICATION_LADWP = 'download_application_ladwp',
  SUBMIT_FINAL_DOCS_3CREN = 'submit_final_docs_3cren',
  SUBMIT_FINAL_DOCS_PCE = 'submit_final_docs_pce',
  SUBMIT_FINAL_DOCS_HIASP = 'submit_final_docs_hiasp',
  SUBMIT_FINAL_DOCS_RECO = 'submit_final_docs_reco',
  SUBMIT_FINAL_DOCS_CAHEEHRA = 'submit_final_docs_caheehra',
  SUBMIT_FINAL_DOCS_WIHEAR = 'submit_final_docs_wihear',
  SUBMIT_FINAL_DOCS_WIHEAR_WX = 'submit_final_docs_wihear_wx',
  SUBMIT_FINAL_DOCS_CATECH = 'submit_final_docs_catech',
  SUBMIT_FINAL_DOCS_3CE = 'submit_final_docs_3ce',
  SUBMIT_FINAL_DOCS_GAHEAR = 'submit_final_docs_gahear',
  SUBMIT_FINAL_DOCS_SUNRUN = 'submit_final_docs_sunrun',
  SUBMIT_FINAL_DOCS_CATECH_WH = 'submit_final_docs_catech_wh',
  SUBMIT_FINAL_DOCS_MASS_SAVE = 'submit_final_docs_mass_save',
  SUBMIT_FINAL_DOCS_NY_CLEAN_HEAT = 'submit_final_docs_ny_clean_heat',
  SUBMIT_FINAL_DOCS_NY_CLEAN_HEAT_CONED = 'submit_final_docs_ny_clean_heat_coned',
  SUBMIT_FINAL_DOCS_CO_XCEL = 'submit_final_docs_co_xcel',
  SUBMIT_FINAL_DOCS_CO_XCEL_AURORA = 'submit_final_docs_co_xcel_aurora',
  SUBMIT_FINAL_DOCS_CO_XCEL_MOUNTAIN_ENERGY = 'submit_final_docs_co_xcel_mountain_energy',
  SUBMIT_FINAL_DOCS_CO_DR_COG = 'submit_final_docs_co_dr_cog',
  SUBMIT_FINAL_DOCS_CA_TECH_SFV = 'submit_final_docs_ca_tech_sfv',
  SUBMIT_FINAL_DOCS_COHEAR = 'submit_final_docs_cohear',
  SUBMIT_FINAL_DOCS_LADWP = 'submit_final_docs_ladwp',
  PROVIDE_PRE_INSTALL_DETAILS = 'provide_pre_install_details',
  PRE_LIMITED_HVAC_ASSESSMENT = 'pre_limited_hvac_assessment',
  PRE_HOME_SAFETY_ASSESSMENT = 'pre_home_safety_assessment',
  PRE_CAS_TESTING = 'pre_cas_testing',
  CONFIRM_INSTALLED_HEAT_PUMP = 'confirm_installed_heat_pump',
  CONFIRM_INSTALLED_WATER_HEATER = 'confirm_installed_water_heater',
  CONFIRM_POST_INSTALL_DETAILS = 'confirm_post_install_details',
  CONFIRM_POST_INSTALL_DETAILS_HEAT_PUMP = 'confirm_post_install_details_heat_pump',
  CONFIRM_POST_INSTALL_DETAILS_WATER_HEATER = 'confirm_post_install_details_water_heater',
  CONFIRM_POST_INSTALL_DETAILS_HEATING = 'confirm_post_install_details_heating',
  CONFIRM_POST_INSTALL_PHOTOS_HEAT_PUMP = 'confirm_post_install_photos_heat_pump',
  CONFIRM_POST_INSTALL_PHOTOS_WATER_HEATER = 'confirm_post_install_photos_water_heater',
  CONFIRM_POST_INSTALL_PHOTOS_GAS_FURNACE = 'confirm_post_install_photos_gas_furnace',
  CONFIRM_POST_INSTALL_PHOTOS_ELECTRICAL = 'confirm_post_install_photos_electrical',
  CONFIRM_POST_INSTALL_DETAILS_EVAPORATIVE_COOLER = 'confirm_post_install_details_evaporative_cooler',
  CONFIRM_POST_INSTALL_DETAILS_VENTILATION = 'confirm_post_install_details_ventilation',
  CONFIRM_POST_INSTALL_PHOTOS_VENTILATION = 'confirm_post_install_photos_ventilation',
  POST_CAS_TESTING = 'post_cas_testing',
  PROVIDE_OTHER_REBATES_DETAILS = 'provide_other_rebates_details',
  PROVIDE_COMMISSIONING_FORM_DETAILS = 'provide_commissioning_form_details',
  SIGN_CENTRAL_HUDSON_ACKNOWLEDGEMENT_NYCH = 'sign_central_hudson_acknowledgement_nych',
  SIGN_CON_EDISON_ACKNOWLEDGEMENT_NYCH_OWNER = 'sign_con_edison_acknowledgement_nych_owner',
  SIGN_CON_EDISON_ACKNOWLEDGEMENT_NYCH_RENTER = 'sign_con_edison_acknowledgement_nych_renter',
  SIGN_NATIONAL_GRID_ACKNOWLEDGEMENT_NYCH = 'sign_national_grid_acknowledgement_nych',
  SIGN_AVANGRID_ACKNOWLEDGEMENT_NYCH = 'sign_avangrid_acknowledgement_nych',
  SIGN_ORU_ACKNOWLEDGEMENT_NYCH = 'sign_oru_acknowledgement_nych',
  SIGN_DECOMMISSIONING_CHECKLIST_NYCH = 'sign_decommissioning_checklist_nych',
  UPLOAD_DECOMMISSIONING_CHECKLIST = 'upload_decommissioning_checklist',
  QUALITY_INSTALLATION_CHECKLIST = 'quality_installation_checklist',
  REVIEW_SITE_DETAILS = 'review_site_details',
  REVIEW_UTILITY_BILLS = 'review_utility_bills',
  REVIEW_INSTALLED_HEAT_PUMP = 'review_installed_heat_pump',
  REVIEW_INSTALLED_WATER_HEATER = 'review_installed_water_heater',
  REVIEW_INSTALLED_EQUIPMENT = 'review_installed_equipment',
  PROVIDE_ADDITIONAL_INCENTIVES_DETAILS = 'provide_additional_incentives_details',
  CONFIRM_INCOME_QUALIFICATION = 'confirm_income_qualification',
  CONFIRM_DECOMMISSIONING_CHECKLIST_DATA = 'confirm_decommissioning_checklist_data',
  REVIEW_QUALITY_INSTALL_REPORT = 'review_quality_install_report',
  REVIEW_COMBUSTION_MECHANICAL_FORM = 'review_combustion_mechanical_form',
  REVIEW_PRE_CAS_TESTING = 'review_pre_cas_testing',
  REVIEW_POST_CAS_TESTING = 'review_post_cas_testing',
  REVIEW_PRE_LIMITED_HVAC_ASSESSMENT = 'review_pre_limited_hvac_assessment',
  REVIEW_PRE_HOME_SAFETY_ASSESSMENT = 'review_pre_home_safety_assessment',
  REVIEW_COMMISSIONING_FORM = 'review_commissioning_form',
  REVIEW_UPLOADED_COMMISSIONING_FORM = 'review_uploaded_commissioning_form',
  REVIEW_UPLOADED_DECOMMISSIONING_FORM = 'review_uploaded_decommissioning_form',
  SUBMIT_OPTIONAL_PRE_APPROVAL = 'submit_optional_pre_approval',
  RECORD_OPTIONAL_PRE_APPROVAL_RESULTS = 'record_optional_pre_approval_results',
  REVIEW_FINAL_INVOICE = 'review_final_invoice',
  CONFIRM_MANUAL_J_REPORT = 'confirm_manual_j_report',
  CONFIRM_EQUIPMENT_CERTIFICATES = 'confirm_equipment_certificates',
  CREATE_SCOPE_OF_WORK = 'create_scope_of_work',
  REVIEW_PERMIT = 'review_permit',
  REVIEW_SIGNED_APPLICATION = 'review_signed_application',
  SUBMIT_JOB_FOR_ENROLLMENT_3CREN = 'submit_job_for_enrollment_3cren',
  SUBMIT_JOB_FOR_ENROLLMENT_PCE = 'submit_job_for_enrollment_pce',
  SUBMIT_JOB_FOR_ENROLLMENT_HIASP = 'submit_job_for_enrollment_hiasp',
  SUBMIT_JOB_FOR_ENROLLMENT_CAHEEHRA = 'submit_job_for_enrollment_caheehra',
  SUBMIT_JOB_FOR_ENROLLMENT_WIHEAR = 'submit_job_for_enrollment_wihear',
  SUBMIT_JOB_FOR_ENROLLMENT_WIHEAR_WX = 'submit_job_for_enrollment_wihear_wx',
  SUBMIT_JOB_FOR_ENROLLMENT_CATECH = 'submit_job_for_enrollment_catech',
  SUBMIT_JOB_FOR_ENROLLMENT_3CE = 'submit_job_for_enrollment_3ce',
  SUBMIT_JOB_FOR_ENROLLMENT_GAHEAR = 'submit_job_for_enrollment_gahear',
  SUBMIT_JOB_FOR_ENROLLMENT_SUNRUN = 'submit_job_for_enrollment_sunrun',
  SUBMIT_JOB_FOR_ENROLLMENT_CATECH_WH = 'submit_job_for_enrollment_catech_wh',
  SUBMIT_JOB_FOR_ENROLLMENT_MASS_SAVE = 'submit_job_for_enrollment_mass_save',
  SUBMIT_JOB_FOR_ENROLLMENT_CO_XCEL = 'submit_job_for_enrollment_co_xcel',
  SUBMIT_JOB_FOR_ENROLLMENT_CO_XCEL_AURORA = 'submit_job_for_enrollment_co_xcel_aurora',
  SUBMIT_JOB_FOR_ENROLLMENT_CO_XCEL_MOUNTAIN_ENERGY = 'submit_job_for_enrollment_co_xcel_mountain_energy',
  SUBMIT_JOB_FOR_ENROLLMENT_CO_DR_COG = 'submit_job_for_enrollment_co_dr_cog',
  SUBMIT_JOB_FOR_ENROLLMENT_CA_TECH_SFV = 'submit_job_for_enrollment_ca_tech_sfv',
  SUBMIT_JOB_FOR_ENROLLMENT_NY_CLEAN_HEAT = 'submit_job_for_enrollment_ny_clean_heat',
  SUBMIT_JOB_FOR_ENROLLMENT_NY_CLEAN_HEAT_CONED = 'submit_job_for_enrollment_ny_clean_heat_coned',
  SUBMIT_JOB_FOR_ENROLLMENT_COHEAR = 'submit_job_for_enrollment_cohear',
  SUBMIT_JOB_FOR_ENROLLMENT_LADWP = 'submit_job_for_enrollment_ladwp',
  RECORD_ENROLLMENT_RESULTS_3CREN = 'record_enrollment_results_3cren',
  RECORD_ENROLLMENT_RESULTS_PCE = 'record_enrollment_results_pce',
  RECORD_ENROLLMENT_RESULTS_HIASP = 'record_enrollment_results_hiasp',
  RECORD_ENROLLMENT_RESULTS_RECO = 'record_enrollment_results_reco',
  RECORD_ENROLLMENT_RESULTS_CAHEEHRA = 'record_enrollment_results_caheehra',
  RECORD_ENROLLMENT_RESULTS_WIHEAR = 'record_enrollment_results_wihear',
  RECORD_ENROLLMENT_RESULTS_WIHEAR_WX = 'record_enrollment_results_wihear_wx',
  RECORD_ENROLLMENT_RESULTS_CATECH = 'record_enrollment_results_catech',
  RECORD_ENROLLMENT_RESULTS_3CE = 'record_enrollment_results_3ce',
  RECORD_ENROLLMENT_RESULTS_GAHEAR = 'record_enrollment_results_gahear',
  RECORD_ENROLLMENT_RESULTS_SUNRUN = 'record_enrollment_results_sunrun',
  RECORD_ENROLLMENT_RESULTS_CATECH_WH = 'record_enrollment_results_catech_wh',
  RECORD_ENROLLMENT_RESULTS_MASS_SAVE = 'record_enrollment_results_mass_save',
  RECORD_ENROLLMENT_RESULTS_NY_CLEAN_HEAT = 'record_enrollment_results_ny_clean_heat',
  RECORD_ENROLLMENT_RESULTS_NY_CLEAN_HEAT_CONED = 'record_enrollment_results_ny_clean_heat_coned',
  RECORD_ENROLLMENT_RESULTS_CO_XCEL = 'record_enrollment_results_co_xcel',
  RECORD_ENROLLMENT_RESULTS_CO_XCEL_AURORA = 'record_enrollment_results_co_xcel_aurora',
  RECORD_ENROLLMENT_RESULTS_CO_XCEL_MOUNTAIN_ENERGY = 'record_enrollment_results_co_xcel_mountain_energy',
  RECORD_ENROLLMENT_RESULTS_CO_DR_COG = 'record_enrollment_results_co_dr_cog',
  RECORD_ENROLLMENT_RESULTS_CA_TECH_SFV = 'record_enrollment_results_ca_tech_sfv',
  RECORD_ENROLLMENT_RESULTS_COHEAR = 'record_enrollment_results_cohear',
  RECORD_ENROLLMENT_RESULTS_LADWP = 'record_enrollment_results_ladwp',
  APPROVE_PAYMENT_3CREN = 'approve_payment_3cren',
  APPROVE_PAYMENT_PCE = 'approve_payment_pce',
  APPROVE_PAYMENT_HIASP = 'approve_payment_hiasp',
  APPROVE_PAYMENT_RECO = 'approve_payment_reco',
  APPROVE_PAYMENT_CAHEEHRA = 'approve_payment_caheehra',
  APPROVE_PAYMENT_WIHEAR = 'approve_payment_wihear',
  APPROVE_PAYMENT_WIHEAR_WX = 'approve_payment_wihear_wx',
  APPROVE_PAYMENT_CATECH = 'approve_payment_catech',
  APPROVE_PAYMENT_3CE = 'approve_payment_3ce',
  APPROVE_PAYMENT_GAHEAR = 'approve_payment_gahear',
  APPROVE_PAYMENT_SUNRUN = 'approve_payment_sunrun',
  APPROVE_PAYMENT_CATECH_WH = 'approve_payment_catech_wh',
  APPROVE_PAYMENT_MASS_SAVE = 'approve_payment_mass_save',
  APPROVE_PAYMENT_NY_CLEAN_HEAT = 'approve_payment_ny_clean_heat',
  APPROVE_PAYMENT_NY_CLEAN_HEAT_CONED = 'approve_payment_ny_clean_heat_coned',
  APPROVE_PAYMENT_CO_XCEL = 'approve_payment_co_xcel',
  APPROVE_PAYMENT_CO_XCEL_AURORA = 'approve_payment_co_xcel_aurora',
  APPROVE_PAYMENT_CO_XCEL_MOUNTAIN_ENERGY = 'approve_payment_co_xcel_mountain_energy',
  APPROVE_PAYMENT_CO_DR_COG = 'approve_payment_co_dr_cog',
  APPROVE_PAYMENT_CA_TECH_SFV = 'approve_payment_ca_tech_sfv',
  APPROVE_PAYMENT_COHEAR = 'approve_payment_cohear',
  APPROVE_PAYMENT_LADWP = 'approve_payment_ladwp',
  SEND_PAYMENT_3CREN = 'send_payment_3cren',
  SEND_PAYMENT_PCE = 'send_payment_pce',
  SEND_PAYMENT_HIASP = 'send_payment_hiasp',
  SEND_PAYMENT_RECO = 'send_payment_reco',
  SEND_PAYMENT_CAHEEHRA = 'send_payment_caheehra',
  SEND_PAYMENT_WIHEAR = 'send_payment_wihear',
  SEND_PAYMENT_WIHEAR_WX = 'send_payment_wihear_wx',
  SEND_PAYMENT_CATECH = 'send_payment_catech',
  SEND_PAYMENT_3CE = 'send_payment_3ce',
  SEND_PAYMENT_GAHEAR = 'send_payment_gahear',
  SEND_PAYMENT_SUNRUN = 'send_payment_sunrun',
  SEND_PAYMENT_CATECH_WH = 'send_payment_catech_wh',
  SEND_PAYMENT_MASS_SAVE = 'send_payment_mass_save',
  SEND_PAYMENT_NY_CLEAN_HEAT = 'send_payment_ny_clean_heat',
  SEND_PAYMENT_NY_CLEAN_HEAT_CONED = 'send_payment_ny_clean_heat_coned',
  SEND_PAYMENT_CO_XCEL = 'send_payment_co_xcel',
  SEND_PAYMENT_CO_XCEL_AURORA = 'send_payment_co_xcel_aurora',
  SEND_PAYMENT_CO_XCEL_MOUNTAIN_ENERGY = 'send_payment_co_xcel_mountain_energy',
  SEND_PAYMENT_CO_DR_COG = 'send_payment_co_dr_cog',
  SEND_PAYMENT_CA_TECH_SFV = 'send_payment_ca_tech_sfv',
  SEND_PAYMENT_COHEAR = 'send_payment_cohear',
  SEND_PAYMENT_LADWP = 'send_payment_ladwp',
  SUBMIT_ENROLLMENT_FOLLOW_UP_3CREN = 'submit_enrollment_follow_up_3cren',
  SUBMIT_ENROLLMENT_FOLLOW_UP_PCE = 'submit_enrollment_follow_up_pce',
  SUBMIT_ENROLLMENT_FOLLOW_UP_HIASP = 'submit_enrollment_follow_up_hiasp',
  SUBMIT_ENROLLMENT_FOLLOW_UP_RECO = 'submit_enrollment_follow_up_reco',
  SUBMIT_ENROLLMENT_FOLLOW_UP_CAHEEHRA = 'submit_enrollment_follow_up_caheehra',
  SUBMIT_ENROLLMENT_FOLLOW_UP_WIHEAR = 'submit_enrollment_follow_up_wihear',
  SUBMIT_ENROLLMENT_FOLLOW_UP_WIHEAR_WX = 'submit_enrollment_follow_up_wihear_wx',
  SUBMIT_ENROLLMENT_FOLLOW_UP_CATECH = 'submit_enrollment_follow_up_catech',
  SUBMIT_ENROLLMENT_FOLLOW_UP_3CE = 'submit_enrollment_follow_up_3ce',
  SUBMIT_ENROLLMENT_FOLLOW_UP_GAHEAR = 'submit_enrollment_follow_up_gahear',
  SUBMIT_ENROLLMENT_FOLLOW_UP_SUNRUN = 'submit_enrollment_follow_up_sunrun',
  SUBMIT_ENROLLMENT_FOLLOW_UP_CATECH_WH = 'submit_enrollment_follow_up_catech_wh',
  SUBMIT_ENROLLMENT_FOLLOW_UP_MASS_SAVE = 'submit_enrollment_follow_up_mass_save',
  SUBMIT_ENROLLMENT_FOLLOW_UP_NY_CLEAN_HEAT = 'submit_enrollment_follow_up_ny_clean_heat',
  SUBMIT_ENROLLMENT_FOLLOW_UP_NY_CLEAN_HEAT_CONED = 'submit_enrollment_follow_up_ny_clean_heat_coned',
  SUBMIT_ENROLLMENT_FOLLOW_UP_CO_XCEL = 'submit_enrollment_follow_up_co_xcel',
  SUBMIT_ENROLLMENT_FOLLOW_UP_CO_XCEL_AURORA = 'submit_enrollment_follow_up_co_xcel_aurora',
  SUBMIT_ENROLLMENT_FOLLOW_UP_CO_XCEL_MOUNTAIN_ENERGY = 'submit_enrollment_follow_up_co_xcel_mountain_energy',
  SUBMIT_ENROLLMENT_FOLLOW_UP_CO_DR_COG = 'submit_enrollment_follow_up_co_dr_cog',
  SUBMIT_ENROLLMENT_FOLLOW_UP_CA_TECH_SFV = 'submit_enrollment_follow_up_ca_tech_sfv',
  SUBMIT_ENROLLMENT_FOLLOW_UP_COHEAR = 'submit_enrollment_follow_up_cohear',
  SEALED_REVIEW = 'sealed_review',
}
